import { render, staticRenderFns } from "./contentName.vue?vue&type=template&id=86f7bcc2"
import script from "./contentName.vue?vue&type=script&lang=js"
export * from "./contentName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports